
import * as Inovx from '@shared';
import assign from 'object-assign';
import { apiPostFormUrlEncoded, FormUrlEncodedBody } from '@shared/api/apiClient';
var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var url = `${UrlUtilities.getApiUrl()}/FacilityApi/api/GraphicSource`;

var GraphicSourceServices: IGraphicSourceServices = assign({}, Inovx.Shared.Flux.BaseService, {

    createGraphicSource: function (data: IGraphicSource) {
        return new Promise<IGraphicSource>((resolve, reject) => {
            apiPostFormUrlEncoded<IGraphicSource>(url + "/Create", data as FormUrlEncodedBody, { responseType: 'text' })
                .then((result: IGraphicSource) => {
                    resolve(result);
                })
                .catch((error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                });

        });
    },
    updateGraphicSource: function (data: IGraphicSource) {
        return new Promise<IGraphicSource>((resolve, reject) => {
            apiPostFormUrlEncoded<IGraphicSource>(url + "/Update", data as FormUrlEncodedBody, { responseType: 'text' })
                .then((result: IGraphicSource) => {
                    resolve(result);
                })
                .catch((error: any) => {
                    this.handleWebApiError(error);
                    reject(error);
                });

        });
    },
    getGraphicSources: function (facilityID: string) {
        return new Promise<IGraphicSource[]>((resolve, reject) => {
            this.get(`${url}/ByFacility`,
                { facilityID: facilityID },
                (retData: IGraphicSource[]) => {
                    resolve(retData)
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
    deleteGraphicSource: function (graphicSource: IGraphicSource) {
        return new Promise<void>((resolve, reject) => {
            this.post(`${url}/Delete`,
                { id: graphicSource.ID, VersionToken: graphicSource.VersionToken },
                () => {
                    resolve();
                },
                (error: IServiceErrorObject) => {
                    this.handleWebApiError(error);
                    reject(error);
                }
            );
        });
    },
});

export default GraphicSourceServices;